import { apiSlice } from "./apiSlice";

export const resetPasswordApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    resetPassword: builder.mutation({
      query: body => ({
        url:"/api/v3/crm/passwords",
        method: "POST",
        body: JSON.parse(JSON.stringify(body)),
      }),
    }),
  }),
});

export const {useResetPasswordMutation} = resetPasswordApiSlice;
